export enum SupportedApps {
    mySAME = "mySAME",
    myDEUTZFAHR = "myDEUTZ-FAHR"
}